import { render, staticRenderFns } from "./edit-wholesaler.vue?vue&type=template&id=2e6eded0"
import script from "./edit-wholesaler.vue?vue&type=script&lang=js"
export * from "./edit-wholesaler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports